import React from 'react';

import { MdOutlineWarning } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Heading } from 'scouting-ui/lib';

import type { RosterAdultMemberWitRegistration } from '@modules/permissionManager/types';
import { Button, Modal, PersonAvatar, S } from '@shared/components';

import styles from '../assignees.less';

interface RegisteredWarningModalProps {
  visible: boolean;
  userGuidList: string[];
  unitUsers?: RosterAdultMemberWitRegistration[];
  onCancel: VoidFunction;
}

export const RegisteredWarningModal = ({
  visible,
  userGuidList,
  unitUsers = [],
  onCancel,
}: RegisteredWarningModalProps) => {
  const users = unitUsers.filter(user =>
    userGuidList.includes(user.personGuid),
  );

  return (
    <Modal
      useNewStyle
      fullscreenMobile={false}
      visible={visible}
      onCancel={onCancel}
      title={
        <Heading level={3} color="color-primary">
          <FormattedMessage id="permissionManager.assignees.unregisteredWarningTitle" />
        </Heading>
      }
      footer={
        <Button
          type="primary"
          shadow
          uppercase
          shape="round"
          onClick={onCancel}
        >
          <FormattedMessage id="shared.ok" />
        </Button>
      }
    >
      <div className={styles.modalContent}>
        <S size="3">
          <FormattedMessage id="permissionManager.assignees.unregisteredWarningMessage" />
        </S>
        {users.map(user => (
          <div key={user.personGuid} className={styles.missingModalItem}>
            <PersonAvatar
              className={styles.personIcon}
              bordered={false}
              pictureUrl={user.pictureUrl || ''}
              isAdult={true}
              gender={user.gender}
            />
            <S size="5" className={styles.personName}>
              {user.personFullName}
              <MdOutlineWarning color="#ffb708" />
            </S>
          </div>
        ))}
      </div>
    </Modal>
  );
};
